jQuery(function ($) {
    // Home Slider
    var productSlider = $('.productSlider');
    var productCardSlider = $('.productCardSlider');

    productSlider.owlCarousel({
        stagePadding: 340,
        loop: false, // Disable looping
        center: true,
        items: 1,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 2000,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        smartSpeed: 600, // Adjust transition speed for smoothness
        responsive: {
            300: { stagePadding: 10 },
            545: { stagePadding: 30 },
            782: { stagePadding: 100 },
            919: { stagePadding: 140 },
            1025: { stagePadding: 180 },
            1201: { stagePadding: 220 },
            1367: { stagePadding: 240 },
            1441: { stagePadding: 270 },
            1601: { stagePadding: 320 }
        }
    });

    // Throttle function to control the frequency of scroll events
    function throttle(func, limit) {
        let inThrottle;
        return function () {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => (inThrottle = false), limit);
            }
        };
    }

    // Mousewheel Scroll for Navigation with Throttle
    productSlider.on(
        'wheel',
        '.owl-stage',
        throttle(function (e) {
            let delta = e.originalEvent.deltaY;

            if (delta > 0) {
                e.preventDefault();
                productSlider.trigger('next.owl.carousel');
            } else {
                e.preventDefault();
                productSlider.trigger('prev.owl.carousel');
            }
        }, 400) // 400ms delay to prevent rapid scrolling
    );

    productCardSlider.owlCarousel({
        loop: true, // Enable infinite loop
        items: 4, // Default number of visible items
        margin: 20, // Space (gap) between slides
        lazyLoad: true,
        autoplay: false,
        autoplayHoverPause: true,
        autoplaySpeed: 2000,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        nav: true, // Enable navigation arrows
        navText: ["<span class='owl-prev'>&#10094;</span>", "<span class='owl-next'>&#10095;</span>"], // Custom arrows
        responsive: {
            0: {
                items: 1, // 1 item on small screens
                margin: 15 // Reduce margin for small screens
            },
            576: {
                items: 2, // 2 items on larger mobile screens
                margin: 20
            },
            768: {
                items: 3, // 3 items on tablets
                margin: 25
            },
            1024: {
                items: 4, // 4 items on desktops
                margin: 30
            },
        }
    });
  
});
